import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import noImage from "../../asset/no image.png";
import { FaRegEdit } from "react-icons/fa";
import {
  useDeleteProfileMutation,
  useGetAllProfilesQuery,
} from "../../redux/managementProfileApi";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { MdEmail, MdOutlineDelete } from "react-icons/md";
import { showConfirmDialog } from "../showConfirmDialog/ShowConfirmDialog";
import { showErrorToast } from "../../utils/Utils";
import { toast } from "react-toastify";
import ButtonLoading from "../Button loading/ButtonLoading";
import { useDebounce } from "use-debounce";

const Management = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1500);
  const { data, isLoading, isFetching } = useGetAllProfilesQuery({
    page,
    search: debouncedSearch,
  });
  const [deleteProfile, { isLoading: isDeleteLoading }] =
    useDeleteProfileMutation();
  const profiles = data?.profiles;
  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < data?.totalPages) setPage((prev) => prev + 1);
  };

  const handleDeleteProfile = async (id) => {
    try {
      const response = await deleteProfile(id).unwrap();
      if (response.success) {
        toast.success(response.message);
      }
    } catch (err) {
      showErrorToast(err);
    }
  };

  const handleDeleteConfrim = (id) => {
    showConfirmDialog({
      title: "Delete Profile",
      message: "Are you sure you want to delete this Profile?",
      type: "danger",
      onConfirm: () => {
        handleDeleteProfile(id);
      },
    });
  };

  return (
    <>
      {isDeleteLoading && (
        <div className="fixed inset-0 flex items-center text-white justify-center bg-[#243F5C4D] backdrop-blur-md z-50">
          <ButtonLoading text="Deleting Profile..." />
        </div>
      )}
      <div className="flex flex-col lg:gap-10 md:gap-6 gap-4 bg-white rounded-xl lg:p-4 p-3 h-full">
        <div className="flex justify-between sm:flex-row flex-col gap-4 sm:items-center">
          <p className="text-[#05004E] font-semibold lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem]">
            Management
          </p>
          <div className=" flex items-center justify-end sm:gap-4 gap-2">
            <NavLink
              to={"/management/sort-management-profile"}
              className="lg:w-[12rem] md:w-[10rem] w-max bg-[#00643b] text-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
            >
              Sort Profile
            </NavLink>
            <NavLink
              to={"/management/add-profile"}
              className="lg:w-[12rem] md:w-[10rem] w-max bg-[#00643b] text-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
            >
              + Add Profile
            </NavLink>
          </div>
        </div>
        <div className=" flex justify-end w-full">
          <input
            type="search"
            placeholder="Search by name, designation..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
            className="border-2 rounded-xl border-[#05004e40] md:p-3 p-2 outline-none md:w-[24rem] md:text-[1rem] text-[.8rem] w-[18rem]"
          />
        </div>
        {data?.totalProfile !== 0 ? (
          isFetching || isLoading ? (
            <TeamCardSkeleton />
          ) : (
            <div className=" flex flex-col gap-4">
              <div className="grid 2xl:grid-cols-5 xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 w-full justify-items-center">
                {profiles?.map((profile, i) => (
                  <div
                    key={i}
                    className="w-full relative bg-[#DEE9E4] group hover:bg-[#00643b] p-4 rounded-2xl "
                  >
                    <div className="absolute  top-5 right-5 shadow-xl border border-[#00643b] py-2 px-4 bg-white rounded-full hidden group-hover:flex items-center justify-center gap-2 text-[#00643b]">
                      <NavLink to={`/management/add-profile/${profile?._id}`}>
                        <FaRegEdit />
                      </NavLink>
                      <button
                        type="button"
                        className=" bg-transparent outline-none"
                        disabled={isDeleteLoading}
                        onClick={() => handleDeleteConfrim(profile?._id)}
                      >
                        <MdOutlineDelete className=" text-red-500" />
                      </button>
                    </div>

                    <img
                      src={
                        profile?.profileImage?.imageUrl
                          ? profile?.profileImage?.imageUrl
                          : noImage
                      }
                      className="rounded-xl w-full aspect-[1/1.2] object-cover"
                      alt=""
                    />
                    <div className="mt-8 text-center relative">
                      <a
                        href={`mailto:${profile?.email}`}
                        className="absolute bg-[#00643b] group-hover:bg-[#fff] py-1.5 px-5 rounded-full text-white group-hover:text-[#00643b] top-[-48px] left-1/2 transform -translate-x-1/2"
                      >
                        <MdEmail className="size-5" />
                      </a>
                      <h1 className="text-[1.1rem] font-semibold group-hover:text-[#fff]">
                        {profile?.fullName}
                      </h1>
                      <p className="text-[.9rem] text-[#343434] group-hover:text-[#fff] font-semibold">
                        {profile?.position}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              {profiles?.length > 0 && (
                <div className=" flex justify-between items-center">
                  <div className=" text-[#0000004f]">
                    Showing record page {data?.currentPage} 0f{" "}
                    {data?.totalPages}
                  </div>
                  <div className=" flex items-center gap-4">
                    <div
                      onClick={handlePrev}
                      disabled={page === 1}
                      className={`bg-[#efefef] p-2  rounded-xl ${
                        page === 1
                          ? " cursor-not-allowed opacity-50"
                          : "cursor-pointer"
                      }`}
                    >
                      <IoIosArrowBack className="size-6" />
                    </div>
                    {data?.currentPage}
                    <div
                      onClick={handleNext}
                      disabled={page === data?.totalPages}
                      className={`bg-[#efefef] p-2  rounded-xl ${
                        page === data?.totalPages
                          ? " cursor-not-allowed opacity-50"
                          : "cursor-pointer"
                      }`}
                    >
                      <IoIosArrowForward className="size-6" />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )
        ) : (
          <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#05004E]">
            No Profile Found
          </div>
        )}
      </div>
    </>
  );
};

const TeamCardSkeleton = () => {
  return (
    <div className="grid 2xl:grid-cols-5 xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 w-full justify-items-center animate-pulse">
      {[...Array(12)].map((_, i) => (
        <div
          key={i}
          className="w-full bg-[#DEE9E4] rounded-2xl p-4 flex flex-col items-center"
        >
          {/* Profile image placeholder */}
          <div className="w-full aspect-[1/1.2] bg-gray-200 rounded-xl"></div>

          {/* Mail button */}
          <div className="relative w-full mt-6 flex justify-center">
            <div className="absolute  h-6 w-12 rounded-2xl top-[-24px] left-1/2 transform -translate-x-1/2 bg-gray-300"></div>
          </div>

          {/* Text placeholders */}
          <div className="mt-8 text-center space-y-2 w-full">
            <div className="h-3 w-3/4 bg-gray-200 rounded mx-auto"></div>
            <div className="h-3 w-1/2 bg-gray-200 rounded mx-auto"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Management;
